import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { OrganizationCompany } from 'types/company';

interface CompanyState {
  company: OrganizationCompany | null;
}

const initialState: CompanyState = {
  company: null
};

export const company = createSlice({
  name: 'company',
  initialState,
  reducers: {
    setLoginCompany: (state, action: PayloadAction<OrganizationCompany | null>) => {
      state.company = action.payload;
    }
  }
});

export default company.reducer;
export const { setLoginCompany } = company.actions;
export const getLoginCompany = (state: { company: CompanyState }) => state.company.company;